<template>
    <div :style="{ height: this.history.length === 0 ? 'calc(100vh - 129px)' : 'auto'}" v-loading.fullscreen.lock="fullscreenLoading">
        <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
        <div class="container">
            <div class="inputDom d-flex justify-content-center">
                <div class="me-2">
                    <h5 class="fs-14">日期：</h5>
                    <el-date-picker
                        v-model="dateVal"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="changeDate">
                    </el-date-picker>
                </div>
                <div class="mx-2">
                    <h5 class="fs-14">联赛选择:</h5>
                    <el-autocomplete
                        class="inline-input"
                        v-model="state"
                        :fetch-suggestions="querySearch"
                        :clearable = true
                        placeholder="输入内容搜索..."
                        @select="selectLg"
                        ></el-autocomplete>
                </div>
                <div class="mx-2">
                    <h5 class="fs-14">比赛选择:</h5>
                    <el-autocomplete
                        class="inline-input"
                        v-model="stateM"
                        :fetch-suggestions="matchSearch"
                        :clearable = true
                        placeholder="输入内容搜索..."
                        @select="selectMatch"
                        ></el-autocomplete>
                </div>
                <div class="mx-2">
                    <h5 class="fs-14">实力差:</h5>
                    <el-input type="number" placeholder="0" v-model="qsda" clearable></el-input>
                </div>
                <div class="mx-2">
                    <h5 class="fs-14">盘口:</h5>
                    <el-input placeholder="0.25" v-model="hd" clearable></el-input>
                </div>
                <div class="mx-2">
                    <h5 class="fs-14">大小</h5>
                    <el-input placeholder="2/2.25" v-model="bs" clearable></el-input>
                </div>
                <div class="ms-2">
                    <h5 class="fs-14">&nbsp;</h5>
                    <el-button class="submit-btn" type="primary" @click="submit">提交</el-button>
                </div>
            </div>
            <div class="res mt-4 h-100">
                <table :class="{'table-dark': isDark}" class="table table-bordered w-100 font-weight-bold mb-0">
                    <tbody class="">
                        <tr class="fw-bold">
                            <td width="136" class="text-white text-center align-middle" :style="'background:'+ this.lgCorler">
                                {{ this.selectLgName }}
                            </td>
                            <td width="82" class="text-center align-middle">{{this.selectTimeStr}}</td>
                            <td class="text-center">
                                <a :href="'https://zq.titan007.com/analysis/'+this.selectMid+'cn.htm'" target='_blank' class="text-decoration-none">
                                <div class="match-team">
                                    <span>
                                        <sup class="fw-normal"><font>{{ this.selectHomeRank }}</font></sup>
                                        {{this.selectHomeName}}
                                    </span>
                                    <span class="mx-4 px-4" :style="{color: qsdaColorSet(this.hd,this.qsda)}">{{this.qsda}}</span>
                                    <span>
                                        {{this.selectAwayName}}
                                        <sup class="fw-normal"><font>{{ this.selectAwayRank }}</font></sup>
                                    </span>
                                </div></a>
                            </td>
                            <td width="135"  class="text-center align-middle"><a :href="'https://live.nowscore.com/analysis/'+this.selectMid+'cn.html'" target='_blank' class="text-decoration-none" style="color: inherit;">{{numToHandicap(this.hd)}}</a></td>
                            <td width="69"  class="text-center align-middle">{{this.bs}}</td>
                        </tr>
                    </tbody>
                </table>
                <el-table :data="history" border stripe style="width: 100%" :cell-style="columnStyle" :header-cell-class-name="headerClass">
                    <el-table-column prop="date" label="日期" width="130"></el-table-column>
                    <el-table-column prop="league" label="时间" width="80"></el-table-column>
                    <el-table-column prop="home" label="主队"></el-table-column>
                    <el-table-column prop="score" label="比分" width="54"></el-table-column>
                    <el-table-column prop="away" label="客队"></el-table-column>
                    <el-table-column prop="qsda" label="qsda" width="60"></el-table-column>
                    <el-table-column prop="state" label="结果" width="65" column-key="state" :filters="result" :filter-method="filterHandler">
                        <template v-slot="scope">
                            <span>{{scope.row.state}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="初/终" width="60">
                        <template>
                            <div>初盘</div>
                            <div>终盘</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="index1" label="指数1" width="60">
                        <template v-slot="scope">
                            <div>{{scope.row.h_index1}}</div>
                            <div>{{scope.row.h_index2}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="crown" label="Crown" width="70">
                        <template v-slot="scope">
                            <div>{{scope.row.init}}</div>
                            <div>{{scope.row.final}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="index2" label="指数2" width="60">
                        <template v-slot="scope">
                            <div>{{scope.row.a_index1}}</div>
                            <div>{{scope.row.a_index2}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="big" label="大球" width="60">
                        <template v-slot="scope">
                            <div>{{scope.row.big_1}}</div>
                            <div>{{scope.row.big_2}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="bigsmall" label="大小球" width="65">
                        <template v-slot="scope">
                            <div>{{scope.row.bs_init}}</div>
                            <div>{{scope.row.bs_final}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="small" label="小球" width="60">
                        <template v-slot="scope">
                            <div>{{scope.row.samll_1}}</div>
                            <div>{{scope.row.samll_2}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Nav from './comment/nav.vue'
import Footer from './comment/footer.vue'
import { checkColor, numToHandicap, dateFormatted,handicapToNum,convertToReal,compare } from '../utils/utils';
export default {
    inject: ['reload'],
    components: { Nav,Footer },
    data() {
        return {
            isDark: false,
            fullscreenLoading: false,
            history: [],
            result: [
                {text: '胜',value: '胜'},
                {text: '平',value: '平'},
                {text: '负',value: '负'}
            ],
            qsda: 0,
            hd: '',
            bs: '',
            dateVal: '',
            state: '',
            stateTm: '',
            stateM: '',
            stateA: '',
            leagueData: [],
            drawdownList: [],
            matchDrawdownList: [],
            selectMid: 0,
            lgCorler: '',
            selectLgName: '',
            selectTimeStr: '',
            selectHomeName: '',
            selectAwayName: '',
            selectHomeRank: '',
            selectAwayRank: '',
            selectMatchHd: '',
            selectMatchBs: '',
            selectLgData: []
        }
    },
    mounted() {
        let date = dateFormatted(new Date());
        this.dateVal = date;
        const url = 'https://api.qsda.net/api/match/date/' + date;
        this.getGsData(url);
    },
    methods:{
        numToHandicap,
        checkcolor(key){
            return checkColor(key)
        },
        async getHistory(qsda,init,bsInit){
            const url = 'https://api.qsda.net/api/match/history?' + 'qsda=' + qsda + '&init=' + init + '&bsInit=' + bsInit + '&pageNum=1&pageSize=20';
            // const url = 'localhost:8888/api/match/history?';
            console.log(url);
            await fetch(url, {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then(response => response.json())
            .then(data => {
                    console.log(data.data.list);
                    this.history = data.data.list;
            });
            console.log(this.history);
        },
        submit(){
            let init = numToHandicap(this.hd);
            // console.log('sssss',init,this.bs);
            // console.log(this.qsda,this.hd,this.bs);
            if (this.hd == '' || this.bs == '') {
                this.$message.error('请输入盘口或大小球值');
                return
            }
            if (this.hd !== '' && this.bs !== '') {
                this.getHistory(this.qsda,init,this.bs);
            }
            
        },
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },
        columnStyle({ row,columnIndex }){
            if(columnIndex > 0){
                if (columnIndex === 6) {
                    return 'background:'+this.checkcolor(row.state)+'!important; text-align: center; color: #000'
                }
                if (columnIndex >= 5) {
                    return 'text-align: center; padding: 0;'
                }
                return 'padding: 0;'
            }
        },
        headerClass({ columnIndex }){
            if (columnIndex>=0) {
                if (columnIndex >=5) {
                    return 'p-0 fs-12 text-center'
                }
                return 'p-0 fs-12'
            }
        },
        changeDate(){
            const date = this.dateVal;
            // console.log(this.dateVal);
            const url = 'https://api.qsda.net/api/match/date/' + date;
            this.getGsData(url);
        },
        getGsData(url){
            fetch(url)
            .then(response => response.json())
            .then(data => {
                this.gsData = data.data;
                this.loading = false;
                let lgArry = [];
                for (let index = 0; index < data.data.length; index++) {
                    const elm = data.data[index];
                    lgArry.push({
                        value: elm.league,
                        id: elm.id,
                        color:elm.color
                    });
                    
                }
                this.drawdownList = [...new Map(lgArry.map(item => [item.value, item])).values()]
                // console.log(this.drawdownList);
            })
            .catch(error => console.error('Error:', error));
        },
        selectLg(command){
            // console.log(command);
            this.selectLgData = [];
            this.matchDrawdownList = [];
            for (let index = 0; index < this.gsData.length; index++) {
                const element = this.gsData[index];
                if (element.league === command.value) {
                    this.selectLgData.push(element);
                    this.matchDrawdownList.push({
                        value: element.home + ' - ' + element.away,
                        id: element.m_id
                    })
                }
            }            
            // console.log(this.selectLgData);
        },
        selectMatch(command){
            // console.log(command);
            // console.log(this.selectLgData);
            for (let index = 0; index < this.selectLgData.length; index++) {
                const elm = this.selectLgData[index];
                if (command.id === elm.m_id) {
                    this.selectMid = elm.m_id
                    this.lgCorler = elm.color;
                    this.selectLgName = elm.league;
                    this.selectTimeStr = elm.time;
                    this.selectHomeName = elm.home;
                    this.selectAwayName = elm.away;
                    this.selectHomeRank = elm.home_rank;
                    this.selectAwayRank = elm.away_rank;
                    this.qsda = elm.qsda;
            // console.log(elm.color,elm.league,elm.home,elm.away);
                }
            }
        },
        querySearch(queryString, cb) {
            var leagueList = this.drawdownList;
            // console.log('0000',leagueList);
            var results = queryString ? leagueList.filter(this.createFilter(queryString)) : leagueList;
            // console.log('1111',results);
            
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        matchSearch(queryString, cb){
            var matchList = this.matchDrawdownList;
            var results = queryString ? matchList.filter(this.createFilter(queryString)) : matchList;
            cb(results);
        },
        createFilter(queryString) {
            return (leagueList) => {
                return (leagueList.value.indexOf(queryString) !== -1);
            };
        },
        qsdaColorSet(handicap,qsda){
            let qsdaColor = 'rgb(128,0,255)';
            let lowOrHight = 2;
            if (handicap!=='') {
                const realHandicapNum = convertToReal(qsda);
                if (handicap === 0) {
                    qsdaColor = 'rgb(128,0,255)';
                    return qsdaColor
                }else{
                    if (typeof handicap !== 'undefined' && typeof realHandicapNum !== 'undefined') {
                            lowOrHight = compare(handicap, realHandicapNum);
                        if(lowOrHight === 0){
                            qsdaColor = this.isDark ? '#ccc' : 'black';
                            return qsdaColor
                        }
                        if (lowOrHight === 1) {
                            qsdaColor = 'red';
                            return qsdaColor
                        }
                        if (lowOrHight === -1) {
                            qsdaColor = 'green';
                            return qsdaColor
                        }
                    }
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import '../assets/sass/global.scss';
    .container {
        height: 100%; padding-top: 66px;
    }
    .table {border-bottom: 1px solid transparent;}
    ::v-deep .elx-table {font-size: 1rem;}
    ::v-deep .el-table__cell {padding: 5px 0!important;}
    ::v-deep .el-table__header{
        font-size: 12px;
    }
    ::v-deep .el-table .el-table__cell {padding: 0;}
    .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {background: #F5F5F5!important;}
    .NIGHT .el-table__row,.NIGHT .el-table th.el-table__cell {
        background-color: #0d1421;
        color: #fff;
    }
    .NIGHT .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell,.NIGHT .el-table, .el-table__expanded-cell {
        background-color: #192336;
    }
    .NIGHT .el-table th.el-table__cell.is-leaf {
        border-bottom: 1px solid #4d5154;
    }
    .NIGHT .el-table--border .el-table__cell {
        border-right: 1px solid #4d5154;
        border-bottom: 1px solid #4d5154;
    }
    .NIGHT .el-table--border {
        border: 1px solid #4d5154;
    }
    .NIGHT .el-table::before,.NIGHT .el-table--border::after {background-color: unset;}
    .NIGHT .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {background-color: #192336;}
    @media (max-width: 1024px) {
        .inputDom {
            flex-direction: column;
            div {
                :first-child
                {
                 margin-bottom: 1rem;}
            }
            div:last-child {
                    p {display: none;}
                }
        }
        .submit-btn {width: 100%;}
    }
</style>